import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { StoreConfiguration } from './scripts/store/storeConfiguration';
import App from './scripts/App';

render(
    <Provider store={StoreConfiguration()}>
        <Router>
            <App />
        </Router>
    </Provider>,
    document.getElementById('root')
);
